import { render, staticRenderFns } from "./KioskContainer.vue?vue&type=template&id=72932bba&scoped=true"
import script from "./KioskContainer.vue?vue&type=script&lang=ts"
export * from "./KioskContainer.vue?vue&type=script&lang=ts"
import style0 from "./KioskContainer.vue?vue&type=style&index=0&id=72932bba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72932bba",
  null
  
)

export default component.exports